import styled from '@emotion/styled';
import { tokens, Text, Button, Link } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';
import { useSelector, useStoreState } from '../../../../store/player/context';
import { ScaleTrialBadge } from './ScaleTrialBadge';
import { useIsConsoleAvailable } from '../../hooks/useIsConsoleAvailable';

const Header = styled.header`
  width: 100%;
  height: 48px;

  display: flex;

  padding: ${tokens.spacer.x1} ${tokens.spacer.x2pt5};

  border-bottom: 1px solid ${tokens.color.ui_border};
  background-color: ${tokens.color.white};
`;

const LeftSection = styled.section`
  flex-grow: 1;

  display: flex;
  align-items: center;
  justify-content: left;
`;

const RightSection = styled.section`
  display: flex;
  align-items: center;
`;

const Title = styled(Text)`
  padding-right: ${tokens.spacer.x2};
`;

const StyledLink = styled(Link)`
  ${tokens.text('body2')};
  margin-right: ${tokens.spacer.x1};
  text-decoration: underline;
`;

const SURVEY_URL = 'https://surveys.hotjar.com/5de5288d-63cf-4e2f-9732-d510c3f95fdc';

export const ConsoleHeader = (): JSX.Element => {
  const { t } = useTranslation();
  const { toggleConsole } = useStoreState();
  const { site } = useSelector(({ site }) => ({ site }));
  const isConsoleAvailable = useIsConsoleAvailable();

  return (
    <Header>
      <LeftSection>
        <Title textType="subtitle2">{t('common:player.console-header')}</Title>
        {site?.effectivePlan === 'business' && isConsoleAvailable ? <ScaleTrialBadge /> : null}
      </LeftSection>

      <RightSection>
        <StyledLink kind="inline" isExternal href={SURVEY_URL}>
          {t('common:player.console-survey-cta')}
        </StyledLink>
        <Button icon="close" kind="ghost" size="s" onClick={toggleConsole}>
          {t('common:player.console-close-button')}
        </Button>
      </RightSection>
    </Header>
  );
};
